// src/Components/LogoutButton.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../utils/api";
import { HiArrowRightOnRectangle } from "react-icons/hi2"; // ✅ 아이콘 추가

export default function LogoutButton({ iconOnly = false }) {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await logout();
    } catch (err) {
      console.error("로그아웃 요청 실패:", err);
    } finally {
      navigate("/login");
    }
  }

  // ✅ 아이콘 버전(UI만 변경, 동작 동일)
  if (iconOnly) {
    return (
      <HiArrowRightOnRectangle
        className="logout-icon"
        title="로그아웃"
        onClick={handleLogout}
        style={{ cursor: "pointer" }}
      />
    );
  }

  // ✅ 기존 버튼 버전 그대로 유지
  return (
    <button
      onClick={handleLogout}
      className="logout button"
      style={{ backgroundColor: "#2c3e50", color: "white" }}
    >
      로그아웃
    </button>
  );
}
